// packages import
import { FC, useState, useEffect } from 'react'
import { Button } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBackIos'
import { useNavigate } from 'react-router-dom'

// component import
import GenerateFundRequestsHeader from '../../../components/billing/generateFundRequests/GenerateFundRequestsHeader'
import CasesWithLowBalanceTable from '../../../components/billing/generateFundRequests/CasesWithLowBalanceTable'
import { CardBox } from '../../../theme/styleComponents'
import { Alert } from '../../../components/common/Alert'

// others
import { useGetCasesWithLowTrustBalanceLazyQuery, CaseWithLowTrustBalancePayload } from '../../../../generated'
import { GRAPHQL_QUERY_POLICY } from '../../../constants'
import { GenerateFundRequestFilters } from '../../../interfaceTypes/props'

export const GenerateFundRequests: FC = (): JSX.Element => {
  const [cases, setCases] = useState<CaseWithLowTrustBalancePayload[] | null>(null)
  const [filters, setFilters] = useState<GenerateFundRequestFilters>({
    attorneyId: undefined,
    case: undefined
  })
  const [selectedCases, setSelectedCases] = useState<string[]>([])

  const navigate = useNavigate()

  const [getCasesWithLowTrustBalance, { loading }] = useGetCasesWithLowTrustBalanceLazyQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: undefined,
    onCompleted: data => {
      if (data?.getCasesWithLowTrustBalance?.cases) {
        setCases(data.getCasesWithLowTrustBalance.cases)
      }
    },
    onError: error => {
      Alert.error(error.message || 'Failed to fetch cases')
      setCases(null)
    }
  })

  const handleBack = () => {
    navigate('/billing/fund-requests')
  }

  useEffect(() => {
    getCasesWithLowTrustBalance({
      variables: { casesWithLowTrustBalanceInput: { attorneyId: filters.attorneyId, caseId: filters.case?.id } }
    })
  }, [getCasesWithLowTrustBalance, filters])

  return (
    <>
      <Button
        startIcon={<ArrowBackIcon sx={{ width: '13px' }} />}
        onClick={handleBack}
        sx={{
          color: '#5B5675',
          fontWeight: 600,
          fontSize: '14px'
        }}
      >
        BACK
      </Button>

      <CardBox sx={{ mt: 3 }}>
        <GenerateFundRequestsHeader
          selectedCases={selectedCases}
          cases={cases}
          filters={filters}
          handleFiltersChange={setFilters}
        />

        <CasesWithLowBalanceTable
          cases={cases}
          loading={loading}
          selectedCases={selectedCases}
          onSelectedCasesChange={setSelectedCases}
        />
      </CardBox>
    </>
  )
}

export default GenerateFundRequests
